const testResultsRequestStore = {
    inFlightByKey: {},
    responseByKey: {},
};

export function testResultsRequestDispatch(action) {
    switch (action.type) {
        case "CACHE_TEST_RESULT_RESPONSE":
            testResultsRequestStore.responseByKey = {
                ...testResultsRequestStore.responseByKey,
                [action.payload.requestKey]: {
                    fetchedAt: Date.now(),
                    response: action.payload.response,
                },
            };
            return;
        case "SET_TEST_RESULT_IN_FLIGHT":
            testResultsRequestStore.inFlightByKey = {
                ...testResultsRequestStore.inFlightByKey,
                [action.payload.requestKey]: action.payload.requestPromise,
            };
            return;
        case "CLEAR_TEST_RESULT_IN_FLIGHT":
            const nextInFlightByKey = {
                ...testResultsRequestStore.inFlightByKey,
            };
            delete nextInFlightByKey[action.payload.requestKey];
            testResultsRequestStore.inFlightByKey = nextInFlightByKey;
            return;
        case "CLEAR_ALL_TEST_RESULT_IN_FLIGHT":
            testResultsRequestStore.inFlightByKey = {};
            return;
        case "CLEAR_TEST_RESULT_CACHE":
            if (action.payload && action.payload.requestKey) {
                const nextResponseByKey = {
                    ...testResultsRequestStore.responseByKey,
                };
                delete nextResponseByKey[action.payload.requestKey];
                testResultsRequestStore.responseByKey = nextResponseByKey;
                return;
            }
            testResultsRequestStore.responseByKey = {};
            return;
        default:
            return;
    }
}

export function testResultsRequestGetState() {
    return testResultsRequestStore;
}
